import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { fetchMe, getCachedUser, getUserToken, clearUserSession, loginUser } from './userApi';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(() => getCachedUser());
    const [loading, setLoading] = useState(false);

    const refresh = useCallback(async () => {
        if (!getUserToken()) {
            setUser(null);
            return null;
        }
        setLoading(true);
        try {
            const me = await fetchMe();
            setUser(me);
            return me;
        } catch (_e) {
            clearUserSession();
            setUser(null);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    // Refresh on mount if we have a token
    useEffect(() => {
        if (getUserToken()) {
            refresh();
        }
    }, [refresh]);

    const login = useCallback(async (email, password) => {
        const data = await loginUser(email, password);
        if (data?.user) setUser(data.user);
        return data;
    }, []);

    const logout = useCallback(() => {
        clearUserSession();
        setUser(null);
    }, []);

    const value = { user, loading, login, logout, refresh, setUser };
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
    return ctx;
}
